// extracted by mini-css-extract-plugin
module.exports = {"ScrollArea":"Swiper_ScrollArea__2aydH","slider":"Swiper_slider__31qvL","noti":"Swiper_noti__34r5e","more":"Swiper_more__7t5ff"};